import makeHTTPRequest from '../makeHTTPRequest';

export const index = () => makeHTTPRequest({ path: '/api/v2/authorizations' });
